
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class Skeleton extends Vue {
  @Prop({ required: true }) loading: boolean
  /**
   * delay毫秒内不会展示loading效果
   */
  @Prop({ default: 500 }) delay: number
  /**
   * loading效果出现后最少展示minDuration毫秒
   */
  @Prop({ default: 200 }) minDuration: number

  visible: boolean = false
  startTime: number = 0
  delayTimer: ReturnType<typeof setTimeout>
  minTimer: ReturnType<typeof setTimeout>

  @Watch('loading', { immediate: true })
  handleLoadingChange(isLoading: boolean) {
    if (isLoading) {
      this.handleStart()
    } else {
      this.handleEnd()
    }
  }

  handleStart() {
    // console.warn('handleStart invoke', this.delay)
    clearTimeout(this.delayTimer)
    clearTimeout(this.minTimer)

    // 延迟展示
    this.delayTimer = setTimeout(() => {
      this.visible = true
      this.startTime = Date.now()
      // console.warn(`handleStart delayTimer执行 visible = true startTime = ${this.startTime}`)
    }, this.delay)
  }

  handleEnd() {
    // console.warn('handleEnd invoke')
    clearTimeout(this.delayTimer)

    // 如果还没展示过，直接结束
    if (!this.visible) {
      // console.log(`handleEnd 还没展示过，直接结束`)
      return
    }

    const elapsed = Date.now() - this.startTime
    const remaining = this.minDuration - elapsed

    // console.log(`handleEnd elapsed = ${elapsed} remaining = ${remaining}`)

    if (remaining > 0) {
      // 不够最小展示时间 → 延迟关闭
      // console.log(`handleEnd 不够最小展示时间 → 延迟关闭`)
      this.minTimer = setTimeout(() => {
        this.visible = false
        // console.log(`handleEnd 不够最小展示时间 → 延迟关闭 visible = false`)
      }, remaining)
    } else {
      // 已满足最小时长 → 立即关闭
      this.visible = false
      // console.log(`handleEnd 已满足最小时长 → 立即关闭`)
    }
  }

  created() {
    // 同步一下初始状态
    // if (this.loading === false) {
    //   this.visible = false
    // }
  }
  mounted() {}
  updated() {}
  destroyed() {
    clearTimeout(this.delayTimer)
    clearTimeout(this.minTimer)
  }
}
